import * as React from "react";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

function ViewDialogFourPart({
  isOpen, //bool
  onCloseHandler,
  columnOneChildren,
  columnTwoChildren,
  actions,
  dialogTitle,
}) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("lg"));

  const handleClose = () => {
    onCloseHandler();
  };

  return (
    <React.Fragment>
      <Dialog
        maxWidth={"md"}
        open={isOpen}
        onClose={handleClose}
        fullScreen={fullScreen}
        PaperProps={{
          style: { borderRadius: "1rem" },
        }}
      >
        <DialogContent>
          <Grid container direction={"row"}>
            <Grid
              item
              xs
              style={{
                display: "flex",
                flexGrow: 1,
              }}
            >
              {columnOneChildren}
            </Grid>
            <Divider orientation="vertical" flexItem />
            <Grid
              item
              xs
              container
              style={{
                display: "flex",
                flexGrow: 2,
                flexDirection: "column",
              }}
            >
              <DialogTitle
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  direction: "row",
                  padding: "8px 0 0 8px",
                }}
              >
                <Typography fontSize={"1.15rem"}>{dialogTitle}</Typography>
                <IconButton aria-label="Close" onClick={handleClose}>
                  <CloseRoundedIcon />
                </IconButton>
              </DialogTitle>
              {columnTwoChildren}
            </Grid>
          </Grid>
        </DialogContent>
        {actions && <DialogActions>{actions}</DialogActions>}
      </Dialog>
    </React.Fragment>
  );
}

export default ViewDialogFourPart;
